document.addEventListener('DOMContentLoaded', (event) => {

    // toggle active class on collapsing card in references
    if (document.getElementById('our-clients')){
        if (document.querySelectorAll('.references__item-detail').length){
            document.querySelectorAll('.references__item-detail').forEach(function(el){
                el.addEventListener('hide.bs.collapse', function(event){
                    document.querySelector('[aria-controls="'+ event.target.id +'"').parentElement.classList.remove('active');
                });
                el.addEventListener('show.bs.collapse', function(event){
                    document.querySelector('[aria-controls="'+ event.target.id +'"').parentElement.classList.add('active');
                });
            });
        };
    };

});